import { httpClientService } from '../settingsApi/httpClientService';

export interface PciSessionContextRequest {
  operation: 'UPDATE_SESSION_PCI_FLAG';
  sessionContext: {
    pci: {
      active: boolean;
    };
  };
}

export interface PciSessionContextUpdateParams {
  sessionId: string;
  payload: PciSessionContextRequest;
}

const PciSessionContextUpdateApi = {
  updatePciSessionContext: async ({
    sessionId,
    payload,
  }: PciSessionContextUpdateParams) => {
    const client = httpClientService.getHttpClient({
      api: 'WALLET',
    });

    const response = await client.request<boolean>({
      url: `/checkout-sessions/${sessionId}/update`,
      method: 'PATCH',
      data: { ...payload },
      suppressGlobalErrorHandler: true,
    });

    return response.data;
  },
};

export default PciSessionContextUpdateApi;
